import get from 'lodash/get';

import apptracker from '@utils/sensor/apptracker';

// list of events we don't want to track any more
const deprecated = [];

// value injected during building
const mode = process.env.pendoMode;

/*
Pendo integration:
https://help.pendo.io/resources/support-library/integrations/track-event-configuration.html

@param props:
{
  event: 'some event name':
  data: {
    key1: 'val1',
    key2: 'val2',
  }
}
*/
function track(props) {
  const { event, data } = props;
  if (!event || deprecated.includes(event)) {
    return;
  }
  switch (mode) {
    case 'remote':
      const track = get(window, 'pendo.track', get(window, 'proxy.pendo.track')); // eslint-disable-line
      if (typeof track === 'function') {
        track(event, data);
      }
      break;
    case 'console':
      window.console.log(props);
      break;
    default:
  }

  // push pendo events to sensor
  apptracker({
    category: 'pendo',
    action: event,
    label: 'NA',
    property: 'NA',
    value: data,
  });
}
export default track;

export const CLICK_FILTERS = 'Click Filters Dropdown';
export const APPLY_DRILL_DOWN = 'Apply drill-down filter';
